import {Dispatch} from "@reduxjs/toolkit";

import {clearReservedMarkers, getReservedMarkerExpiresAt, writeReservedMarker} from "../utils/reservation_marker_storage";
import {clearReservedByMe, markReservedByMe} from "./reservation_slice";

// The slice and its persisted markers always change together

export const markPropertyReservedByMe = (propertyId: number, now: number) => (dispatch: Dispatch) => {
    const expiresAt = getReservedMarkerExpiresAt(now);

    dispatch(markReservedByMe({propertyId, expiresAt}));
    writeReservedMarker(propertyId, expiresAt, now);
};

export const clearPropertiesReservedByMe = () => (dispatch: Dispatch) => {
    clearReservedMarkers();
    dispatch(clearReservedByMe());
};
import {Dispatch} from "@reduxjs/toolkit";

import {clearReservedMarkers, getReservedMarkerExpiresAt, writeReservedMarker} from "../utils/reservation_marker_storage";
import {clearReservedByMe, markReservedByMe} from "./reservation_slice";

// The slice and its persisted markers always change together

export const markPropertyReservedByMe = (propertyId: number, now: number) => (dispatch: Dispatch) => {
    const expiresAt = getReservedMarkerExpiresAt(now);

    dispatch(markReservedByMe({propertyId, expiresAt}));
    writeReservedMarker(propertyId, expiresAt, now);
};

export const clearPropertiesReservedByMe = () => (dispatch: Dispatch) => {
    clearReservedMarkers();
    dispatch(clearReservedByMe());
};
